import { Badge as Mui4Badge, BadgeProps as Mui4BadgeProps } from '@material-ui/core'
import { default as Mui5Badge, BadgeProps as Mui5BadgeProps } from '@mui/material/Badge'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'

export enum OsBadgeVersion {
  V1 = 1, // OS UI 2.0
  V2 = 2, // MUI5 + Stratis
}

type BadgeSizes = Mui5BadgeProps['size']
type BadgeEmphasis = Mui5BadgeProps['emphasis']
type BadgeColor = Mui5BadgeProps['color']
type BadgeVariant = Mui5BadgeProps['variant']
type BadgeChildren = Mui5BadgeProps['children']
type BadgeContent = Mui5BadgeProps['badgeContent']
type BadgeInvisible = Mui5BadgeProps['invisible']
export type BadgeProps = {
  id?: string
  size?: BadgeSizes
  emphasis?: BadgeEmphasis
  color?: BadgeColor
  variant?: BadgeVariant
  children?: BadgeChildren
  startIcon?: React.ReactNode
  label?: React.ReactNode
  badgeContent?: BadgeContent
  invisible?: BadgeInvisible
}

// * MUI Badge API Spec  https://mui.com/material-ui/api/badge/
export const Badge = forwardRef<HTMLSpanElement, BadgeProps>((props, ref) => {
  void ref
  const version = useComponentVersion('badge')

  let {
    size = 'medium',
    emphasis = 'subtle',
    color = 'primary',
    children,
    variant = 'standard',
    startIcon,
    label,
    ...rest
  } = props

  switch (version) {
    case OsBadgeVersion.V2:
      return (
        <Mui5Badge
          size={size}
          emphasis={variant === 'dot' ? 'intense' : emphasis}
          color={color}
          variant={variant}
          {...rest}
        >
          {variant === 'standard' &&
            (!!children ? (
              children
            ) : (
              <>
                {startIcon}
                {label}
              </>
            ))}
        </Mui5Badge>
      )
    default:
      return <Mui4Badge {...(props as Mui4BadgeProps)} />
  }
})

// extend the spec
declare module '@mui/material/Badge' {
  interface BadgeOwnProps {
    size: 'small' | 'medium' | 'large'
    emphasis: 'subtle' | 'intense'
  }
  interface BadgePropsColorOverrides {
    default: false
    secondary: false
  }
}
